<template lang="html">
<div>
  <toolbar title="New Company"></toolbar>
  <v-layout column>

    <v-layout column class="mt-2">
      <v-card class="py-2 pl-5">
        <v-layout align-baseline>
          <div class="title mr-3 mt-4">
            New Company
          </div>
        </v-layout>
        <v-layout column sm6>
          <v-layout>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Company Name" browser-autocomplete="off"
                            v-model="companyName"/>
            </v-flex>
            <v-flex sm3 class="mr-5">
              <v-text-field label="EIN" v-model="ein" />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Contact Name"
                            browser-autocomplete="off"
                            v-model="contactName"/>
            </v-flex>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Contact Email"
                            browser-autocomplete="off"
                            v-model="contactEmail"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm3 class="mr-5">
            </v-flex>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Phone"
                            browser-autocomplete="off"
                            v-model="contactPhone"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Website URL"
                            browser-autocomplete="off"
                            v-model="website"/>
            </v-flex>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Logo URL"
                            browser-autocomplete="off"
                            v-model="logoUrl"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Night Contact Name"
                            browser-autocomplete="off"
                            v-model="nightContactName"/>
            </v-flex>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Night Phone"
                            browser-autocomplete="off"
                            v-model="nightPhone"/>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout align-baseline>
          <div class="title mr-3 mt-4">
            Address
          </div>
        </v-layout>
        <v-layout column sm6>
          <v-layout>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Street"
                            browser-autocomplete="off"
                            v-model="addressStreet1"/>
            </v-flex>
            <v-flex sm3 class="mr-5">
              <v-text-field label="City"
                            browser-autocomplete="off"
                            v-model="addressCity"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Suite or Building Number"
                            browser-autocomplete="off"
                            v-model="addressStreet2"/>
            </v-flex>
            <v-flex sm3 class="mr-5">
              <v-text-field label="State"
                            browser-autocomplete="off"
                            v-model="addressRegion"/>
            </v-flex>
          </v-layout>
          <v-layout>
          </v-layout>
          <v-layout>
            <v-flex sm3 class="mr-5">
            </v-flex>
            <v-flex sm3 class="mr-5">
              <v-text-field label="Postal Code"
                            browser-autocomplete="off"
                            v-model="addressPostalCode"/>
            </v-flex>
          </v-layout>

        </v-layout>
        <v-layout>
          <v-flex sm3 class="mr-5">
            <v-btn class="accent" @click="createCompany">
              Create Company
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>

    </v-layout>
  </v-layout>
  </div>
</template>

<script>
import API from '@/api';
import * as types from '@/store/mutationTypes';
import Toolbar from '@/components/Toolbar';

export default {
  name: 'NewCompany',
  components: {
    Toolbar,
  },
  data: () => ({
    ein: null,
    companyName: null,
    contactEmail: null,
    addressStreet1: null,
    addressStreet2: null,
    addressCity: null,
    addressRegion: null,
    addressPostalCode: null,

    logoUrl: null,
    website: null,
    contactName: null,
    contactPhone: null,
    nightPhone: null,
    nightContactName: null,

  }),
  methods: {
    async createCompany() {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        const response = await API.company.create({ company: {
          ein: this.ein,
          companyName: this.companyName,
          contactEmail: this.contactEmail,
          companyAddress: {
            label: `${this.companyName} Main Address`,
            street1: this.addressStreet1,
            street2: this.addressStreet2,
            city: this.addressCity,
            region: this.addressRegion,
            postalCode: this.addressPostalCode,
          },

          logoUrl: this.logoUrl,
          website: this.website,
          contactName: this.contactName,
          contactPhone: this.contactPhone,
          nightPhone: this.nightPhone,
          nightContactName: this.nightContactName,
        } });

        const company = response.data;

        this.$store.dispatch('companies/getCompany', { id: company.id });
        this.$store.dispatch('applications/setSuccessNotification', {
          message: `${company.companyName} created (${company.id})`,
          timeout: 7000,
        });
        this.$router.push(`/companies/${company.id}/profile`);
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message || 'Error creating company',
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/Companies/NewCompany.vue